/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MultipleReturnGetAlertCallAnswersDto } from '../../models/multiple-return-get-alert-call-answers-dto';

export interface ApiAlertcallsIdAnswersGet$Params {
    /**
     * id
     */
    id: number;
}

export function apiAlertcallsIdAnswersGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiAlertcallsIdAnswersGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<MultipleReturnGetAlertCallAnswersDto>> {
    const rb = new RequestBuilder(rootUrl, apiAlertcallsIdAnswersGet.PATH, 'get');
    if (params) {
        rb.path('id', params.id, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<MultipleReturnGetAlertCallAnswersDto>;
        }),
    );
}

apiAlertcallsIdAnswersGet.PATH = '/api/alertcalls/{id}/answers';
